export class Address {
  static format(address) {
    if (!address) {
      return null;
    }

    if (address.geolocation) {
      delete address.geolocation;
    }

    let formattedAddress = address.street ? `${address.street}, ` : "";
    formattedAddress = formattedAddress.concat(
      address.number ? `${address.number} | ` : ""
    );

    formattedAddress = formattedAddress.concat(
      address.complement ? `${address.complement} | ` : ""
    );

    formattedAddress = formattedAddress.concat(
      address.neighborhood ? `${address.neighborhood} - ` : ""
    );

    formattedAddress = formattedAddress.concat(
      address.city ? `${address.city}/` : ""
    );

    formattedAddress = formattedAddress.concat(
      address.state ? `${address.state} ` : ""
    );

    formattedAddress = formattedAddress.concat(
      address.zipcode
        ? `(${address.zipcode.replace(/^(\d{5})(\d)/, "$1-$2")})`
        : ""
    );

    return formattedAddress;
  }
}
